<template>
    <div class="choose-contract-version">
        <div class="list">
            <div class="item h-align" v-for="(item, index) in contractVersionList" :key="index">
                <div class="radio-group h-align" :class="{'active': checked === item.id}">
                    <radio v-model="checked" :val="item.id" :isPropChecked="checked === item.id"></radio>
                    <img class="type-icon" v-if="item.contractMode === 'CHARTER'" src="@/assets/img/component/contractVersion/charter.svg" alt="">
                    <img class="type-icon" v-else-if="item.contractMode === 'ESCROW'" src="@/assets/img/component/contractVersion/escrow.svg" alt="">
                    <div class="type-text" :class="{'charter': item.contractMode === 'CHARTER', 'escrow': item.contractMode === 'ESCROW'}">{{item.contractMode === 'CHARTER'?'包租':'代管'}}</div>
                    <div class="version-name">{{item.name}}</div>
                </div>
                <dot-dropmenu>
                    <ul>
                        <li @click="previewContractVersion(item.id)">預覽</li>
                        <li v-if="item.name !== '預設合約'" @click="editContract(item.id)">編輯合約</li>
                    </ul>
                </dot-dropmenu>
            </div>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import radio from '@/components/bussiness/widges/input/radio.vue';
import { 
    getContractVersionList
    } from "@/apis/company/contractVersion.js"; 
export default {
    data () {
        return {
            contractVersionList: [],
            checkVal: null,
        }
    },
    props: {
        isEdit: false,
        reload: 0,
        value: '',
    },
    created (){
        this.getContractVersionList()
    },
    destroyed (){
        this.$store.dispatch('setBizEditContractVersionMode', null)
        this.$store.dispatch('setBizContractVersionMode', null)
    },
    watch: {
        reload: function (val){
            if(val){
                this.getContractVersionList()
            }
        },
        value: {
            handler: function (val){
                console.log(val)
                this.setContractVersionMode(val)
            },
            immediate: true
        }
    },
    methods: {
        getContractVersionList: function () {
            console.log('取得合約版本列表')
            getContractVersionList()
            .then( res => {
                if(res.data.status === 'SUCCESS'){
                    this.contractVersionList = res.data.result
                    if(!this.value){
                        this.$emit('input', this.getDefaultContractVersionId())
                    }
                    this.setContractVersionMode(this.value)
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setContractVersionMode: function (val) {
            const list = this.contractVersionList
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(val === element.id){
                    if(this.isEdit){
                        this.$store.dispatch('setBizEditContractVersionMode', element.contractMode)
                    }else{
                        this.$store.dispatch('setBizContractVersionMode', element.contractMode)
                    }
                }
            }
        },
        previewContractVersion: function (id) {
            let routeData = this.$router.resolve({name:'contractPaper',query:{cid:id, mode: 'version'}});
            window.open(routeData.href, '_blank');
        },
        editContract: function (id) {
            this.$emit('edit')
            let routeData = this.$router.resolve({name: 'bizEditContractVersion', query:{contractVerId: id}});
            window.open(routeData.href, '_blank');
        },
        getDefaultContractVersionId: function () {
            let list = this.contractVersionList
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.name === '預設合約'){
                    return element.id
                }
                
            }
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
                this.$emit('input', val)
            }
        }
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        radio
    }
}
</script>
<style lang="scss" scoped>
.choose-contract-version{
    .list{
        .item{
            margin-bottom: 16px;
            .radio-group {
                width: 1052px;
                border-radius: 6px;
                border: solid 1px #f3f3f3;
                background-color: #ffffff;
                padding: 0 16px;
                box-sizing: border-box;
                margin-right: 16px;
                height: 56px;
                &.active{
                    border: solid 1px #ff9275;
                }
                .radio{
                    margin-right: 8px;
                }
                .type-icon{
                   width: 24px; 
                   margin-right: 2px;
                }
                .type-text{
                    position: relative;
                    margin-right: 25px;
                    &::after{
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #e1e1e1;
                        right: -12px;
                    }
                    &.charter{
                        color: #3942b5;
                    }
                    &.escrow{
                        color: #fcb773;
                    }
                }
                .version-name{
                    font-size: 16px;
                    font-weight: 500;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/addHouse/chooseContractVersion.vue